import { render, staticRenderFns } from "./AppCopyText.vue?vue&type=template&id=3fdb459a&"
import script from "./AppCopyText.vue?vue&type=script&lang=js&"
export * from "./AppCopyText.vue?vue&type=script&lang=js&"
import style0 from "./AppCopyText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports